export default {
  getOperadores: state => state.operadores,
  getOperador: state => state.operador,
  getRoutes: state => state.routes,
  getQueues: state => state.queues,
  getDepartamentos: state => state.departamentos,
  getFilaById: state => id => state.queues.find(fila => fila._id === id) || {},
  getOperadoresMonitor: state => state.operadoresMonitor,
  getGruposDeRotas: state => state.gruposDeRotas,
}
